import React from 'react';
import { PageTitle } from '../../_core/_ui/typography.component';
import { Typography } from '@material-ui/core';
import { Link, Redirect } from 'react-router-dom';
import GroupStageHandlerGraphQL from '../../AssessmentStage/GroupStageHandler/group-stage-handler.graphql';
import SessionStageHandlerGraphQL from '../../AssessmentStage/SessionStageHandler/session-stage-handler.graphql';
import RouteStageHandlerGraphQL from '../../AssessmentStage/RouteStageHandler/route-stage-handler.graphql';
import { useCompanyHasAutomation } from '../../../lib/stores/company.store';
import { HOME_ROUTE } from '../../../../_configuration';

interface IManageAgeGroup {
  ageGroup?: IAgeGroup;
  loading: boolean;
  fetchError: boolean;
}

const HANDLERS: { [key: string]: React.FC<any> } = {
  GROUP: GroupStageHandlerGraphQL,
  SESSION: SessionStageHandlerGraphQL,
  ROUTE: RouteStageHandlerGraphQL
};

const ManageAgeGroup: React.FC<IManageAgeGroup> = ({
  ageGroup,
  loading,
  fetchError
}) => {
  const hasAutomation = useCompanyHasAutomation()

  if (!ageGroup)
    if (loading) return <Typography>Loading...</Typography>;
    else if (fetchError) return <Typography>Unable to manage age groups at this time. Please try again later</Typography>;
    else return <Redirect to={HOME_ROUTE} />

  const CurrStageComponent = !!ageGroup.currentStage && HANDLERS[ageGroup.currentStage.type];
  const NextStageComponent = !!ageGroup.nextStage && HANDLERS[ageGroup.nextStage.type];

  return (
    <div>
      <PageTitle>{ageGroup.name}</PageTitle>
      {!ageGroup.currentStage && !ageGroup.nextStage && hasAutomation && (
        <Typography>Next schedule stage is not set up. <Link to="/format">Create a schedule format</Link></Typography>
      )}
      {!!CurrStageComponent && <CurrStageComponent stage={ageGroup.currentStage} ageGroup={ageGroup} />}
      {!!NextStageComponent && <NextStageComponent isNext stage={ageGroup.nextStage} ageGroup={ageGroup} />}
    </div>
  );
};

export default ManageAgeGroup;
